let $ = jQuery;
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

let filterClass = '.js-landing-page-filters';

class LandingPageFilters {

  constructor(elem) {
    this.$wrapper = $(elem);
    this.$filters = this.$wrapper.find('.landing-page-filters__group');
    this.$filterToggles;

    if (this.$wrapper.parents('.js').length) {
      this.styleFilters();
    }
  }

  styleFilters() {
    // jQuery formatted selector to search for focusable items
    this.focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

    // Make sure we're hiding the label and showing the button.
    this.$filters.each((index, elem) => {
      var $wrapper = $(elem);
      var $dropdown = $wrapper.find('.fieldgroup');

      $wrapper.find('legend').addClass('hide');
      $wrapper.find('.js-filter-toggle').removeClass('hide');
      // IE is not paying attenton to click through css, so we change layer.
      $dropdown.css('z-index', '-1');
      // toggle tabindexes.
      this.toggleTabbing($wrapper);
    });

    this.toggleClearFilters();

    // Once done styling bind.
    this.bind();

    this.$wrapper.addClass('js-ready');

    this.checkForDefaultOpen();
  }

  checkForDefaultOpen() {

    this.$filters.each((index, elem) => {
      let $elem = $(elem);
      let $toggle = $elem.find(".js-filter-toggle");


      if ($elem.hasClass("open-on-load")) {
        $toggle.trigger("click");
      }
    });
  }

  bind() {
    this.$filterToggles = this.$filters.find('.js-filter-toggle');

    this.$filterToggles.off('click.filterToggle').on('click.filterToggle', (e) => this.handlToggleClick(e));

    this.$filters.find("input[type=checkbox]").on('click', (e) => this.activateApply(e));

    $(window).resize(() => this.resizeFilters()).trigger('resize');
  }

  activateApply(e) {
    var $applyFilterBtn = this.$wrapper.find('.apply-filters');
    var $checkedFilters = this.$filters.find("input[type=checkbox]:checked");
    if ($checkedFilters.length > 0) {
      $applyFilterBtn.addClass("active");
    }
    else {
      $applyFilterBtn.removeClass("active");
    }

  }

  handlToggleClick(e) {
    e.preventDefault();

    var $target = $(e.currentTarget);
    var $wrapper = $target.parents('.landing-page-filters__group');
    var $siblings = $wrapper.siblings('.landing-page-filters__group');

    // First make sure other dropdowns are closed.
    this.closeDropDown($siblings);

    if (!$wrapper.hasClass('filter-open')) {
      this.openDropDown($wrapper);
    }
    else if ($wrapper.hasClass('filter-open')) {
      this.closeDropDown($wrapper);
    }
  }

  openDropDown($wrapper) {
    var $button = $wrapper.find('.js-filter-toggle');
    var $filters = $wrapper.find('.fieldgroup');

    var targetHeight = $button.outerHeight() + $filters.outerHeight();

    if (!$wrapper.hasClass('filter-open')) {
      $wrapper.addClass('filter-open');
    }

    window.TweenLite.to($wrapper, .25, {
      'height' : targetHeight,
      onStart: () => {
        $filters.css('z-index', '0');
      },
      onComplete: () => {
        this.toggleTabbing($wrapper);
      }
    });
  }

  closeDropDown($wrapper) {
    var $button = $wrapper.find('.js-filter-toggle');
    var $filters = $wrapper.find('.fieldgroup');
    var targetHeight = $button.outerHeight();

    if ($wrapper.hasClass('filter-open')) {
      $wrapper.removeClass('filter-open');
    }

    window.TweenLite.to($wrapper, .25, {
        'height' : targetHeight,
        onComplete: () => {
          this.toggleTabbing($wrapper);
          $filters.css('z-index', '-1');
          $filters.find("input[input='checkbox']").off("change.filter");
        }
      }
    );
  }

  toggleClearFilters() {
    var $checksboxes = this.$filters.find("input[type=checkbox]");
    var anythingChecked = false;
    var $clearFilterBtn = this.$wrapper.find('.clear-filters');

    $.each($checksboxes, (i, e) => {
      if (e.checked) {
        anythingChecked = true;
      }
    });

    if (anythingChecked) {
      $clearFilterBtn.addClass('visible');
    }
    else {
      $clearFilterBtn.removeClass('visible');
    }
  }

  resizeFilters() {
    var $activeWrapper = this.$wrapper.find('.filter-open');

    if ($activeWrapper.length) {
      this.openDropDown($activeWrapper);
    }
  }

  /*
    Loops through the wrapper - for each focusable elements in that wrapper
    set tabindex to 0 otherwise set to -1 or 0.
  */
  toggleTabbing($wrapper) {

    $.each($wrapper, (index, elem) => {
      var $filter = $(elem).find('.fieldgroup');
      var children = $filter.find('*');
      var tabindex = $(elem).hasClass('filter-open') ? 0 : -1;

      // get list of focusable items
      var focusableItems = children.filter(this.focusableElementsString);

      $.each(focusableItems, (index, elem) => {
        $(elem).attr('tabindex', tabindex);
      });
    });
  }
}

function init() {

  if($(filterClass).length) {

    $.each($(filterClass), (index, elem) => {
      let landingPageFilters = new LandingPageFilters(elem);
    });
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function(context, settings) {
      init();
    }
  }
}
